import { PortDetail } from "./port.model";

export class Slot {
    id : string;
    name: string;
    status : string;
    oltPortDetailsList : PortDetail[];
  }